import { render, staticRenderFns } from "./KerstinSocial.vue?vue&type=template&id=40b6d903"
import script from "./KerstinSocial.vue?vue&type=script&lang=js"
export * from "./KerstinSocial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports